import jscookies from 'js-cookie';
import { LegacyStoreNames } from '../enums';
/*
 * Some cookies are stored in a double encoded form e.g. `"foo"`. While we only want to parse the true value,
 *  `foo`, we need to read/write to the double encoded version still so that we don't break compatibility.
 */
export function parseDomain(host) {
    // https://github.com/squareup/public-web-styles/blob/master/app/assets/javascripts/public-web-styles/modules/tracking.js.es6#L97-L108
    const domain_match = /[^.]*\.([^.]*|..\...|...\...)$/.exec(host);
    const ip_match = /^[\d.]+$/.exec(host);
    if (!ip_match && domain_match) {
        return `.${domain_match[0]}`;
    }
    else {
        return undefined;
    }
}
const cookieOptions = {
    expires: 365 * 3, // default to three years
    path: '/',
};
function get(name) {
    if (name === undefined)
        return jscookies.get();
    let store = jscookies.get(name);
    if (Object.values(LegacyStoreNames).includes(name) && store) {
        store = store.slice(1, -1);
    }
    return store;
}
function set(name, value) {
    let store = value;
    if (Object.values(LegacyStoreNames).includes(name)) {
        store = window.JSON.stringify(store);
    }
    if (!cookieOptions.domain) {
        cookieOptions.domain = parseDomain(window.location.hostname);
    }
    return jscookies.set(name, store, cookieOptions);
}
export const cookies = {
    remove: jscookies.remove,
    set,
    get,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29va2llcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jZHAvdXRpbHMvY29va2llcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFNBQVMsTUFBTSxXQUFXLENBQUM7QUFDbEMsT0FBTyxFQUFFLGdCQUFnQixFQUFFLE1BQU0sVUFBVSxDQUFDO0FBQzVDOzs7R0FHRztBQUVILE1BQU0sVUFBVSxXQUFXLENBQUMsSUFBWTtJQUN0QyxzSUFBc0k7SUFDdEksTUFBTSxZQUFZLEdBQUcsZ0NBQWdDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2pFLE1BQU0sUUFBUSxHQUFHLFVBQVUsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdkMsSUFBSSxDQUFDLFFBQVEsSUFBSSxZQUFZLEVBQUUsQ0FBQztRQUM5QixPQUFPLElBQUksWUFBWSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUM7SUFDL0IsQ0FBQztTQUFNLENBQUM7UUFDTixPQUFPLFNBQVMsQ0FBQztJQUNuQixDQUFDO0FBQ0gsQ0FBQztBQUVELE1BQU0sYUFBYSxHQUErQjtJQUNoRCxPQUFPLEVBQUUsR0FBRyxHQUFHLENBQUMsRUFBRSx5QkFBeUI7SUFDM0MsSUFBSSxFQUFFLEdBQUc7Q0FDVixDQUFDO0FBSUYsU0FBUyxHQUFHLENBQUMsSUFBYTtJQUN4QixJQUFJLElBQUksS0FBSyxTQUFTO1FBQUUsT0FBTyxTQUFTLENBQUMsR0FBRyxFQUFFLENBQUM7SUFDL0MsSUFBSSxLQUFLLEdBQUcsU0FBUyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUNoQyxJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQVMsZ0JBQWdCLENBQUMsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLElBQUksS0FBSyxFQUFFLENBQUM7UUFDcEUsS0FBSyxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDN0IsQ0FBQztJQUNELE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQztBQUVELFNBQVMsR0FBRyxDQUFDLElBQVksRUFBRSxLQUFhO0lBQ3RDLElBQUksS0FBSyxHQUFHLEtBQUssQ0FBQztJQUNsQixJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQVMsZ0JBQWdCLENBQUMsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQztRQUMzRCxLQUFLLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDdkMsQ0FBQztJQUNELElBQUksQ0FBQyxhQUFhLENBQUMsTUFBTSxFQUFFLENBQUM7UUFDMUIsYUFBYSxDQUFDLE1BQU0sR0FBRyxXQUFXLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUMvRCxDQUFDO0lBQ0QsT0FBTyxTQUFTLENBQUMsR0FBRyxDQUFDLElBQUksRUFBRSxLQUFLLEVBQUUsYUFBYSxDQUFDLENBQUM7QUFDbkQsQ0FBQztBQUVELE1BQU0sQ0FBQyxNQUFNLE9BQU8sR0FBRztJQUNyQixNQUFNLEVBQUUsU0FBUyxDQUFDLE1BQU07SUFDeEIsR0FBRztJQUNILEdBQUc7Q0FDSixDQUFDIn0=